import { ReactNode, useCallback, useMemo } from "react";
import Addicon from "@mui/icons-material/Add";
import UserLineIcon from "remixicon-react/UserLineIcon";
import { Button as UIButton } from "@mui/material";

import { InfoContainer, Table, Text } from "$components";
import { User } from "$types/User";
import useStyles from "./useStyles";

type Props = {
  handleAddUserClick: () => void;
  handleEditUserClick: (user: User) => void;
  users: User[];
};

function Contacts({ handleAddUserClick, handleEditUserClick, users }: Props) {
  const classes = useStyles();
  const renderCell = useCallback(
    (user: User, value: ReactNode) => ({
      value,
      isDisable: user.isDisable,
      onClickAction: user.isDisable
        ? undefined
        : () => handleEditUserClick(user),
    }),
    [handleEditUserClick]
  );

  const tableHead = [
    { id: "contact", label: "contact" },
    { id: "email", label: "e-mail" },
    { id: "phone", label: "tél. mobile" },
    { id: "isUser", label: "utilisateur" },
  ];

  const tableBody = useMemo(
    () =>
      users && users.length
        ? users.map((u) => [
            renderCell(
              u,
              <Text type="important">
                {u.firstname} {u.lastname}
              </Text>
            ),
            renderCell(u, <Text>{u.email}</Text>),
            renderCell(u, <Text>{u.phone || "N/A"}</Text>),
            renderCell(u, <Text>{u.isOnlyContact ? "Non" : "Oui"}</Text>),
          ])
        : [],
    [renderCell, users]
  );

  return (
    <div style={{ display: "flex" }}>
      <InfoContainer
        isToggleable
        leftHeader={
          <div className={classes.infoHeader}>
            <UserLineIcon />
            <Text type="h3">Contacts</Text>
          </div>
        }
        rightHeader={
          <UIButton
            onClick={handleAddUserClick}
            style={{ textTransform: "none" }}
            className={classes.textButton}
          >
            <Addicon />
            <Text>Ajouter un contact</Text>
          </UIButton>
        }
      >
        <Table
          bodyMissingLabelText="Cet entrepôt n'a pas encore de contacts"
          className={classes.noPaddingTable}
          rowsPerPage={8}
          thead={tableHead}
          bodyData={tableBody}
          usePaper={false}
        />
      </InfoContainer>
    </div>
  );
}

export default Contacts;
